import { render, staticRenderFns } from "./seminarEnrollmentStatistic.vue?vue&type=template&id=12a93919&scoped=true&"
import script from "./seminarEnrollmentStatistic.vue?vue&type=script&lang=js&"
export * from "./seminarEnrollmentStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a93919",
  null
  
)

export default component.exports